import gql from "graphql-tag";
import { PageFragment } from "../fragments/page.fragment";
import { PaymentGatewayFragment } from "../fragments/payment-gateway.fragment";

export const GET_PAYMENT_GATEWAYS = gql`
  query (
    $paging: CursorPaging
    $filter: PaymentGatewayFilter
    $sorting: [PaymentGatewaySort!]
  ) {
    paymentGateways(paging: $paging, filter: $filter, sorting: $sorting) {
      pageInfo {
        ...Page
      }
      edges {
        node {
          ...PaymentGateway
        }
      }
    }
  }

  ${PaymentGatewayFragment}
  ${PageFragment}
`;
